module.exports = __webpack_public_path__ + "img/mini-023.3861fd05.jpg";